import React from "react";
import { useNavigate } from "react-router-dom";
import { ContentSubTitleWrapper } from "./HomeContentSubTitleStyle";
import RightArrowSvg from "assets/icons/keyboard_arrow_right.svg";
import Modal from "components/common/modal/Modal";
import HomeModalContent from "components/pages/home/HomeModalContents";
import { useState } from "react";

const authLevel = localStorage.getItem("level");
const FLOWER_SEARCH_CERT_TEXT =
  "꽃 검색은 사업자 인증을 완료한 회원만 이용할 수 있는 기능이에요.";

const HomeContentSubTitle = ({ title, routingTitle, path }) => {
  const navigate = useNavigate();
  const [isOpenModal, setOpenModal] = useState(false);
  const closeModal = () => setOpenModal(false);

  const authRouting = () => {
    const isAuthentication = typeof authLevel === "number" && authLevel <= 1;

    if (!isAuthentication && path === "/dashboard") {
      setOpenModal(true);
      return;
    } else {
      navigate(path);
    }
  };
  return (
    <>
      <ContentSubTitleWrapper>
        <h2>{title}</h2>
        <div onClick={() => authRouting()}>
          <p>{routingTitle}</p> <img src={RightArrowSvg} alt="" />
        </div>
      </ContentSubTitleWrapper>
      <Modal isOpen={isOpenModal} onClose={closeModal}>
        <HomeModalContent
          content={FLOWER_SEARCH_CERT_TEXT}
          onClose={closeModal}
        />
      </Modal>
    </>
  );
};

export default HomeContentSubTitle;
